import styled from 'styled-components';

import type { ReactNode } from 'react';

export const AuthTitleSection = ({
  title,
  description,
}: {
  children?: ReactNode;
  title: string;
  description?: string;
}) => {
  return (
    <Section>
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
    </Section>
  );
};

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 4.8rem;
`;

const Title = styled.h2`
  ${({ theme }) => theme.getFontStyle('samsung-700-32')};
  color: ${({ theme }) => theme.getColor('black')};
`;

const Description = styled.p`
  ${({ theme }) => theme.getFontStyle('samsung-400-16')};
  color: ${({ theme }) => theme.getColor('gray', '03')};
  margin-top: 1rem;
`;
